<script lang="ts">
    import { isArray } from "chart.js/helpers";
    import type { FilterData } from "./FilterToggleButtonType.svelte";
    import jQuery, { event } from "jquery";
    import BootstrapVectorIcon from "./BootstrapVectorIcon.svelte";
    import Autocomplete from "./Autocomplete.svelte";

    let {
        filterData = $bindable()
    }:{
        filterData: FilterData<any>
    } = $props();

    function filterTypingHandler(ev: KeyboardEvent) {
        ev.preventDefault();

        if(!filterData.multiselect) {
            if(filterData.currentFilterValue == "") {
                filterData.isOn = false;
            } else {
                filterData.isOn = true;
            }
        } else {
            if (ev.key === 'Enter' || ev.keyCode === 13) {
                let newFilterLabel: string = jQuery(ev.target).val() as string;
                if(!filterData.currentFilterValue || !isArray(filterData.currentFilterValue)) {
                    filterData.currentFilterValue = [];
                }
                (filterData.currentFilterValue as string[]).push(newFilterLabel.toLowerCase());
                jQuery(ev.target).val("");
                if(filterData.currentFilterValue.length > 0) {
                    filterData.isOn = true;
                } else {
                    filterData.isOn = false;
                }
            }
        }
    }

    function onAutocomplete(element: string) {
        console.log("Test");
        if(isArray(filterData.currentFilterValue)) {
            filterData.currentFilterValue.push(element);
        } else {
            filterData.currentFilterValue = element;
        }
    }

    function empty(ev: Event) {
        filterData.currentFilterValue = "";
        filterData.isOn = false;
    }


    function remove(ev: Event) {
        let filterValue: string = jQuery(ev.currentTarget).attr("data-filterValue");
        if(!filterValue) {
            return;
        }

        let i: number = filterData.currentFilterValue.indexOf(filterValue);

        if(i<0) {
            return;
        }

        (filterData.currentFilterValue as string[]).splice(i, 1);
        console.log("Test");

        if((filterData.currentFilterValue as string[]).length <= 0) {
            filterData.isOn = false;
        }
    }
</script>
{#if filterData}
    {#if filterData.multiselect}
        <div class="input-group mb-3">

            {#if filterData.candidateCatalogue && filterData.candidateCatalogue.length > 0}
                <Autocomplete catalogue={filterData.candidateCatalogue} onAutocompleteSelection={onAutocomplete}
                ></Autocomplete>
            {:else}
            <input
                type="text"
                class="form-control"
                placeholder="Filter..."
                onkeyup={filterTypingHandler}
                aria-describedby="button-addon2"
            />
            <button class="btn btn-light" type="button" onclick={empty}>X</button>
            {/if}
        </div>

        {#if filterData.currentFilterValue}
            {#each filterData.currentFilterValue as v}
                <button data-filterValue="{v}" class="btn p-1" type="button" onclickcapture={remove}>
                    {v}
                    <BootstrapVectorIcon icon="x" style="height: 1em; width: 1em;"></BootstrapVectorIcon>
                </button>
            {/each}            
        {/if}
    
    {:else}
        <div class="input-group mb-3">
            <input
                id="filter_{filterData.id}"
                type="text"
                class="form-control"
                placeholder="Filter..."
                bind:value={filterData.currentFilterValue}
                onkeyup={filterTypingHandler}
                aria-describedby="button-addon2"
            />
            <button class="btn btn-light" type="button" onclick={empty}>X</button>
        </div>
    {/if}

{/if}
